import { useLang } from '@/i18n';
import EcoPicture from 'eco-design/base/eco-picture';
import css from './index.module.scss';
import { useProductState } from '../../ProductProvider';
import { IPageStatus } from '../../config/IPageStatus';

const C: React.FC = () => {
    const { t } = useLang('ces2026.C');
    const { pageStatus } = useProductState();
    const IS_STAGE_1 = pageStatus === IPageStatus.STAGE_1;

    return (
        <div id="ces-2026-C" className={`ces-2026-C ${css.section} GtmModuleData-section`} data-section-id={'ces-2026-C'}>
            <div className="img-bg">
                <EcoPicture
                    webp={['https://websiteoss.ecoflow.com/upload/image/1765940115691/C_bg.webp']}
                    jpg={['https://websiteoss.ecoflow.com/upload/image/1765940115759/C_bg.jpg']}
                    alt={t('title')}
                />
            </div>
            <div className="info">
                <p className="title-big">{t('title')}</p>
                <p className="desc">{t('desc')}</p>
            </div>
            <div className="content">
                <div className="msg">
                    <p className="title">{t('name')}</p>
                    {IS_STAGE_1 && <p className="desc sub">{t('subtitle')}</p>}
                    <p className="desc">{t('text')}</p>
                </div>
                <div className="brands">
                    <EcoPicture
                        jpg={[
                            IS_STAGE_1
                                ? 'https://websiteoss.ecoflow.com/upload/image/1765940662371/C1.png'
                                : 'https://websiteoss.ecoflow.com/upload/image/1765940662022/C2.png',
                        ]}
                        alt={t('name')}
                    />
                </div>
                {/* {IS_STAGE_1 && <div className="cover"></div>} */}
            </div>
        </div>
    );
};

export default C;
